/**
 * 首屏登录探测门闩：仅在整页加载后、第一次 checkLogin 完成前阻塞其它请求。
 * resolve 后同一页面生命周期内不再阻塞（与后续点击触发的业务接口一致）。
 */
var resolveGate = null
var gatePromise = new Promise(function (resolve) {
  resolveGate = resolve
})

export function waitForLoginGate () {
  return gatePromise
}

export function resolveLoginGate () {
  if (typeof resolveGate === 'function') {
    var r = resolveGate
    resolveGate = null
    r()
  }
}
